// Shared palette + formatters for the admin dashboard charts.
//
// Categorical hues are assigned in FIXED order to the cashin-type entities
// and validated with the dataviz six-checks script (CVD ΔE >= 12.5 on the
// worst adjacent pair, contrast >= 3:1 on white). Green #5A9E2F stays
// reserved for "loan disbursed" — the entity color it has carried since the
// first chart version — and is never reused inside the collections stack.
export const LOAN_COLOR = '#5A9E2F'

export const COLLECTION_COLORS: Record<
    keyof Omit<IAdminMonthlyCollections, 'total'>,
    string
> = {
    portion: '#0A93A6',
    repayment: '#7C4DBE',
    custom: '#D97706',
    hibah: '#3B6FD4',
    misc: '#C2417B',
}

export const COLLECTION_LABELS: Record<
    keyof Omit<IAdminMonthlyCollections, 'total'>,
    string
> = {
    portion: 'حق عضویت',
    repayment: 'قسط وام',
    custom: 'افزایش موجودی',
    hibah: 'هبه',
    misc: 'سایر',
}

// stack order (bottom -> top); the palette was validated in this order
export const COLLECTION_STACK: (keyof Omit<
    IAdminMonthlyCollections,
    'total'
>)[] = ['portion', 'repayment', 'custom', 'hibah', 'misc']

export const faCompact = new Intl.NumberFormat('fa-IR', {
    notation: 'compact',
})
export const faFull = new Intl.NumberFormat('fa-IR')

// axis ticks live inside the chart's dir="ltr" island, which flips
// «۳۰۰ میلیون» to digits-first-on-the-left; RLE…PDF re-embeds the label
// as RTL so the digits sit to the right of «میلیون» again
export const faAxisTick = (value: number) =>
    `‫${faCompact.format(value)}‬`

export const toman = (value: number) =>
    `${faFull.format(Number(value || 0))} تومان`

// «تیر ۱۴۰۵» -> «تیر» for axis ticks (the tooltip keeps the full label)
export const monthOnly = (label: string) => label.split(' ')[0]

// Annotation colour for the average overlay. Deliberately achromatic: it is a
// reading OF the bars, not another category alongside them, and a sixth hue in
// the collections stack would have to be validated against the other five for
// CVD separation all over again.
export const AVERAGE_COLOR = '#98A2B3'

export const mean = (values: number[]) =>
    values.length
        ? values.reduce((sum, value) => sum + value, 0) / values.length
        : 0
